import { IContact } from '../typings/IContact';
import { getClientFullName } from './clientNameHelper';

export const formatUserProfile = (profile: IContact) => {
  return `${getClientFullName(profile.fullName, profile.firstName, profile.lastName)} ${profile.phone || ''} ${profile.email || ''} ${profile.company || ''}`;
};
